export default "__VITE_ASSET__8feda413__"